export default __webpack_public_path__ + "static/media/kbg.a8882e91.jpeg";